import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

interface ProjectContextType {
  project: { id: string; slug: string; name: string } | undefined;
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [projectSlug, setProjectSlug] = useState<string | undefined>(undefined);
  const [routeProjectSlug, setRouteProjectSlug] = useState<string | undefined>(undefined);

  const knownProjects: Record<string, { id: string; name: string }> = {
    'gwent': { id: 'f64fdcde-250b-41d6-ad48-dcc2454fd66c', name: 'Gwent Golf Union' },
    // Add more projectSlug: { id, name } mappings here if needed
  };

  const project = projectSlug && knownProjects[projectSlug]
    ? { id: knownProjects[projectSlug].id, slug: projectSlug, name: knownProjects[projectSlug].name }
    : undefined;

  console.log("🧩 Computed project:", project);

  useEffect(() => {
    const params = window.location.pathname.split('/');
    console.log("🌍 Pathname:", window.location.pathname);
    const projectsIndex = params.indexOf('projects');
    const potentialSlug = projectsIndex !== -1 ? params[projectsIndex + 1] : undefined;
    const validSlug = potentialSlug && knownProjects[potentialSlug] ? potentialSlug : 'gwent';
    setRouteProjectSlug(validSlug);
  }, []);

  useEffect(() => {
    if (!routeProjectSlug) {
      console.warn("🚫 No route projectSlug provided.");
      return;
    }

    const matchedProjectId = knownProjects[routeProjectSlug];
    if (matchedProjectId) {
      console.log("📦 Setting projectSlug and project from route:", routeProjectSlug);
      setProjectSlug(routeProjectSlug);
    } else {
      console.warn("❌ Unknown projectSlug:", routeProjectSlug);
    }
  }, [routeProjectSlug]);

  if (!projectSlug || !project) {
    console.log("⏳ Waiting for project context...");
    return <div>Loading project...</div>;
  }

  console.log("🧩 Project context computed:", projectSlug, project);

  return (
    <ProjectContext.Provider value={{ project }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = (): ProjectContextType => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProjectContext must be used within a ProjectProvider');
  }
  return context;
};

export const useProject = (): ProjectContextType['project'] => {
  const context = useProjectContext();
  return context.project;
};